const React = require('react');
const Swipe = require('../../Swipe');
const SLIDESHOW_SINGLE_COL_WIDTH = 1025;

class PropertySlideshow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: 0,
            innerWidth: 0,
        };

        this.onResize = this.onResize.bind(this);
        this.setActiveSlide = this.setActiveSlide.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
        this.onResize();
        this.refs.swipe.swiper.on('slideChangeEnd', this.setActiveSlide);
    }

    setActiveSlide() {
        this.setState({selected: this.refs.swipe.swiper.activeIndex});
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
        this.refs.swipe.swiper.off('slideChangeEnd', this.setActiveSlide);
    }

    onResize() {
        const {innerWidth} = window;
        this.setState({
            innerWidth
        });
    }

    renderSlidesMobile() {
        const {slides} = this.props;

        return slides.map((slide, index) => {
            return (
                <div key={`${index}`} className="property-slideshow__slide">
                    <div className="property-slideshow__content-container">
                        {slide.title && <h2 className="property-slideshow__title">{slide.title}</h2>}
                        {slide.link && <a href={slide.link} className="property-slideshow__link">Les mer</a>}
                    </div>

                    <div className="property-slideshow__image-container"
                         style={{backgroundImage: `url(${slide.image})`}}>
                        <img src={slide.image}/>
                    </div>
                </div>
            )
        })
    }

    renderSlidesDesktop() {
        const {slides} = this.props;
        const loopSlides = [];

        slides.reduce((acc, slide, index) => {
            acc.push(slide);
            if (index % 2 !== 0) {
                loopSlides.push(acc);
                return [];
            }
            return acc;
        }, []);
        return loopSlides.map((loopSlide, li) => {
            return (
                <div key={`slide-${li}`} className="property-slideshow__slide">
                    {loopSlide.map((slide, i) => {
                        return (
                            <div className={`property-slideshow__slide-${i % 2 === 0 ? 'left' : 'right'}`}>
                                <div className={`property-slideshow__content-container-${i % 2 === 0 ? 'left' : 'right'}`}>
                                    <div className="property-slideshow__content-container">
                                    {slide.title && <h2 className="property-slideshow__title">{slide.title}</h2>}
                                    {slide.link &&
                                    <a href={slide.link} className="property-slideshow__link">Les mer</a>}
                                </div>
                                </div>

                                <div className="property-slideshow__image-container"
                                     style={{backgroundImage: `url(${slide.image})`}}>
                                    <img src={slide.image}/>
                                </div>
                            </div>
                        )
                    })}
                </div>
            );
        })
    }

    render() {
        const {innerWidth} = this.state;
        const {selected} = this.state;
        const isMobile = innerWidth <= SLIDESHOW_SINGLE_COL_WIDTH;
        const {slides} = this.props;
        const number = isMobile ? slides.length : Math.ceil(slides.length / 2);

        return (
            <section className="property-slideshow">
                <Swipe ref="swipe" options={{loop: false, centeredSlides: true, slidesPerView: 'auto'}} pagination={false}>
                    {isMobile ? this.renderSlidesMobile() : this.renderSlidesDesktop()}
                </Swipe>
                {number > 1 && (
                    <div className="property-slideshow__dots">
                        {[...Array(number)].map((slide, i) => {
                            const isSelected = i === selected;
                            return (
                                <button key={i} className={['property-slideshow__dot', isSelected ? 'property-slideshow__dot--selected' : ''].join(' ')} onClick={() => this.refs.swipe.swiper.slideTo(i)} disabled={isSelected}/>
                            );
                        })}
                    </div>
                )}
            </section>
        )
    }
}

module.exports = PropertySlideshow;




// WEBPACK FOOTER //
// ./src/main/resources/site/parts/property-slideshow/Component/index.jsx